/**
 * Convert a time string (e.g., "06:00" or "06:00:00") into
 * the total number of minutes since midnight.
 *
 * Useful for comparing or highlighting time ranges such as
 * start/end periods in calendar or schedule components.
 *
 * @param {string | null | undefined} timeString - The time string in "HH:mm" or "HH:mm:ss" format.
 * @returns {number | null} The total number of minutes since midnight, or `null` if input is invalid.
 *
 * @example
 * timeToMinutes("06:00");    // 360
 * timeToMinutes("06:30:00"); // 390
 * timeToMinutes(null);       // null
 */
export function timeToMinutes(timeString?: string | null): number | null {
    if (!timeString) return null;

    const parts = timeString.split(":").map((n) => parseInt(n, 10));

    if (parts.length < 2 || isNaN(parts[0]) || isNaN(parts[1])) {
        return null;
    }

    const [hours, minutes] = parts;
    return hours * 60 + minutes;
}
